import moment from 'moment-timezone';

// TODO(serhalp) just centralize this in po-api and expose dropoff window start and end as actual
// Dates on the /purchase_orders and /line_items endpoints... This is ridiculous. This set of values
// and how they map to real dates is duplicated in several codebases. :(
export function getTimes(dropoffWindow) {
  switch (dropoffWindow) {
    case '12am-2am':
      return {start: 0, end: 2};
    case '1am-3am':
      return {start: 1, end: 3};
    case '2am-4am':
      return {start: 2, end: 4};
    case '3am-5am':
      return {start: 3, end: 5};
    case '4am-6am':
      return {start: 4, end: 6};
    case '5am-7am':
      return {start: 5, end: 7};
    case '6am-8am':
      return {start: 6, end: 8};
    case '7am-9am':
      return {start: 7, end: 9};
    case '8am-10am':
      return {start: 8, end: 10};
    case '9am-11am':
      return {start: 9, end: 11};
    case '10am-12pm':
      return {start: 10, end: 12};
    case '11am-1pm':
      return {start: 11, end: 13};
    case '12pm-2pm':
      return {start: 12, end: 14};
    case '1pm-3pm':
      return {start: 13, end: 15};
    case '2pm-4pm':
      return {start: 14, end: 16};
    case '3pm-5pm':
      return {start: 15, end: 17};
    case '4pm-6pm':
      return {start: 16, end: 18};
    case '5pm-7pm':
      return {start: 17, end: 19};
    case '6pm-8pm':
      return {start: 18, end: 20};
    case '7pm-9pm':
      return {start: 19, end: 21};
    case '8pm-10pm':
      return {start: 20, end: 22};
    case '9pm-11pm':
      return {start: 21, end: 23};
    case '10pm-12am':
      return {start: 22, end: 23.99};
    case 'third-party-carrier':
      return {start: 12, end: 12};
    default:
      console.warn({dropoffWindow}, 'unexpected dropoff window on PO');
      return {start: 12, end: 12}; // default to noon for unexpected windows
  }
}

export function getDropoffWindowFromDropoffWindowString(dropoffWindowString) {
  const {start: startHour, end: endHour} = getTimes(dropoffWindowString);
  return {
    startAt: moment(startHour, 'H').format('HH:mm'),
    endAt: moment(Math.ceil(endHour), 'H').format('HH:mm'),
  };
}

export function getDropoffWindowStringFromDropoffWindowTimes(dropoffWindow) {
  if (dropoffWindow != null && dropoffWindow.startAt != null && dropoffWindow.endAt != null) {
    const {startAt, endAt} = dropoffWindow;
    return `${moment(startAt, 'H:mm').format('ha')}-${moment(endAt, 'H:mm').format('ha')}`;
  }

  return null;
}

const getPurchaseOrderDropoffTimestampFunctionFor = (startOrEnd) =>
  function(purchaseOrder, tzid) {
    const hours = getTimes(purchaseOrder.dropoffWindow)[startOrEnd];
    return moment
      .tz(purchaseOrder.dropoffDay, 'YYYY-MM-DD', tzid)
      .startOf('day')
      .add({hours})
      .toDate();
  };

export default {
  start: getPurchaseOrderDropoffTimestampFunctionFor('start'),
  end: getPurchaseOrderDropoffTimestampFunctionFor('end'),
};
